import styled, { keyframes } from 'styled-components'
import variables from '../../styles/variables'

const slideInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`

export const TableContainer = styled.div`
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  margin: 2rem 0;
  border: 1px solid ${variables.colors.greyLight};
`

export const TableTitle = styled.h3`
  background: ${variables.colors.backgroundLight};
  padding: 1rem 1.5rem;
  margin: 0;
  font-size: 1.1rem;
  font-weight: 600;
  color: ${variables.colors.textPrimary};
  border-bottom: 1px solid #e0e0e0;
`

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
`

export const TableHeader = styled.thead`
  background: ${variables.colors.backgroundLight};
`

export const TableHeaderCell = styled.th`
  padding: 0.75rem 1rem;
  text-align: left;
  font-weight: 600;
  font-size: 0.875rem;
  color: ${variables.colors.textMuted};
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 1px solid #e0e0e0;
  
  &:first-child {
    padding-left: 1.5rem;
  }
  
  &:last-child {
    padding-right: 1.5rem;
  }
`

export const TableBody = styled.tbody``

export const TableRow = styled.tr`
  border-bottom: 1px solid ${variables.colors.greyLightest};
  transition: all 0.3s ease;
  
  &:hover {
    background: ${variables.colors.backgroundLight};
  }
  
  &.table-row--fraud {
    background: #272344;
    color: white;
    
    &:hover {
      background: #342951;
    }
  }
  
  &.animate {
    animation: ${slideInUp} 0.6s ease-out forwards;
    opacity: 0;
  }
  
  &:last-child {
    border-bottom: none;
  }
`

export const TableCell = styled.td`
  padding: 1rem;
  font-size: 0.875rem;
  color: ${variables.colors.textPrimary};
  vertical-align: middle;
  
  .table-row--fraud & {
    color: white;
  }
  
  &:first-child {
    padding-left: 1.5rem;
    font-weight: 500;
  }
  
  &:last-child {
    padding-right: 1.5rem;
  }
`

export const PredictionBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 0.25rem 0.75rem;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  
  &.prediction--approved {
    background: #d4edda;
    color: #155724;
  }
  
  &.prediction--fraud {
    background: #f8d7da;
    color: #721c24;
  }
  
  &.prediction--review {
    background: #fff3cd;
    color: #856404;
  }
  
  .table-row--fraud &.prediction--fraud {
    background: #ff6b6b;
    color: white;
  }
`

export const ConfidenceBar = styled.div`
  position: relative;
  width: 60px;
  height: 20px;
  background: #e2e8f0;
  border-radius: 10px;
  overflow: hidden;
`

export const ConfidenceFill = styled.div`
  height: 100%;
  background: linear-gradient(90deg, #48bb78, #38a169);
  border-radius: 10px;
  width: ${props => props.confidence * 100}%;
  transition: width 0.8s ease-out;
  
  .table-row--fraud & {
    background: linear-gradient(90deg, #ff6b6b, #e53e3e);
  }
`

export const ConfidenceText = styled.span`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 0.625rem;
  font-weight: 600;
  color: ${variables.colors.textPrimary};
  text-shadow: 0 1px 2px rgba(255, 255, 255, 0.8);
  
  .table-row--fraud & {
    color: white;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  }
`

export const TableFooter = styled.div`
  background: ${variables.colors.backgroundLight};
  padding: 1rem 1.5rem;
  border-top: 1px solid #e0e0e0;
`

export const TableStats = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 0.875rem;
  color: #718096;
  
  span:not(:last-child):not(:nth-child(even)) {
    font-weight: 500;
  }
`